import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { Alert, Dialog, Text } from "@flat-ui";
import { useOnGroupRemoved } from "@hooks/use-on-group-removed";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { fetchGroupDetails, removeGroup } from "@store/groups/groups-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { GroupEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Confirmation dialog for deleting a group. The group is deleted by unassigning all of its
 * members, which includes the group managers that a workspace without manager assignment never
 * gets to see in the members table.
 */
export function DeleteGroupDialog(t0) {
  const $ = _c(20);
  const {
    group,
    onClose
  } = t0;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isRemovingGroup
  } = useAppSelector(fetchingGroupsFlagsSelector);
  let t1;
  if ($[0] !== companyId || $[1] !== group.name) {
    t1 = {
      companyId,
      groupName: group.name
    };
    $[0] = companyId;
    $[1] = group.name;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onGroupRemoved = useOnGroupRemoved(t1);
  let t2;
  if ($[3] !== companyId || $[4] !== dispatch || $[5] !== group.id || $[6] !== group.members || $[7] !== onClose || $[8] !== onGroupRemoved || $[9] !== trackEvent) {
    t2 = async function deleteGroup() {
      trackEvent({
        name: GroupEvents.deleteGroup,
        props: {
          numberOfMembers: group.members.length
        }
      });
      try {
        await dispatch(removeGroup({
          companyId,
          groupId: group.id,
          members: group.members
        })).unwrap();
        onClose();
        onGroupRemoved();
      } catch {
        dispatch(fetchGroupDetails({
          companyId,
          groupId: group.id
        }));
        onClose();
      }
    };
    $[3] = companyId;
    $[4] = dispatch;
    $[5] = group.id;
    $[6] = group.members;
    $[7] = onClose;
    $[8] = onGroupRemoved;
    $[9] = trackEvent;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const deleteGroup = t2;
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "text.primary",
      mb: SPACE_ELEMENTS_OF_MODAL
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== group.name) {
    t4 = <Text variant="bodyM" sx={t3}>All members of{" "}<var><b>{group.name}</b></var>{" "}will be unassigned and lose the access granted by this group.</Text>;
    $[12] = group.name;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Alert variant="warning" title="Deleted groups cannot be recovered." />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== deleteGroup || $[16] !== isRemovingGroup || $[17] !== onClose || $[18] !== t4) {
    t6 = <Dialog title="Delete group?" confirmText="Delete" open={true} onConfirm={deleteGroup} onCancel={onClose} showSpinner={isRemovingGroup} disabled={isRemovingGroup} variant="danger">{t4}{t5}</Dialog>;
    $[15] = deleteGroup;
    $[16] = isRemovingGroup;
    $[17] = onClose;
    $[18] = t4;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}